import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initTheme } from "./components/ThemeToggle";

// Force scroll to top on every refresh (prevents map/scroll restoration).
if (typeof window !== "undefined") {
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
  window.scrollTo(0, 0);
}

// Suppress harmless AbortError + dead message channel noise.
(function silenceKnownNoise() {
  if (typeof window === "undefined") return;
  const isNoise = (val) => {
    if (!val) return false;
    if (val.name === "AbortError") return true;
    const m = String((val && val.message) || val || "");
    return (
      m.includes("signal is aborted") ||
      m.includes("AbortError") ||
      m.includes("message channel closed")
    );
  };
  window.addEventListener("unhandledrejection", (e) => {
    if (isNoise(e.reason)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  window.addEventListener("error", (e) => {
    if (isNoise(e.error) || isNoise({ message: e.message })) {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }, true);
})();

(function hideCraErrorOverlay() {
  if (typeof window === "undefined") return;
  const style = document.createElement("style");
  style.textContent = `
    body > iframe[style*="z-index: 2147483647"],
    iframe#webpack-dev-server-client-overlay { display: none !important; }
  `;
  document.head.appendChild(style);
})();

initTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
